import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement> & {
  d: string;
  size?: number;
  color?: string;
};

type ComponentIconProps = Omit<IconProps, 'd'>;

export const Icon = ({ d, size = 20, color = 'currentColor', className, ...props }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <path d={d} />
  </svg>
);

export const HomeIcon = (p: ComponentIconProps) => <Icon {...p} d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />;
export const VideoIcon = (p: ComponentIconProps) => <Icon {...p} d="m22 8-6 4 6 4V8Z M2 6h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z" />;
export const MessageSquareIcon = (p: ComponentIconProps) => <Icon {...p} d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />;
export const MoreHorizontalIcon = (p: ComponentIconProps) => <Icon {...p} d="M12 12h.01 M19 12h.01 M5 12h.01" />;
export const SettingsIcon = (p: ComponentIconProps) => <Icon {...p} d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.1a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />;
export const PlusIcon = (p: ComponentIconProps) => <Icon {...p} d="M12 5v14 M5 12h14" />;
export const CalendarIcon = (p: ComponentIconProps) => <Icon {...p} d="M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />;
export const ClockIcon = (p: ComponentIconProps) => <Icon {...p} d="M12 6v6l4 2 M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z" />;
export const DownloadIcon = (p: ComponentIconProps) => <Icon {...p} d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4 M7 10l5 5 5-5 M12 15V3" />;
export const SearchIcon = (p: ComponentIconProps) => <Icon {...p} d="M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.35-4.35" />;
export const ChevronDownIcon = (p: ComponentIconProps) => <Icon {...p} d="m6 9 6 6 6-6" />;
export const ChevronLeftIcon = (p: ComponentIconProps) => <Icon {...p} d="m15 18-6-6 6-6" />;
export const ClipboardIcon = (p: ComponentIconProps) => <Icon {...p} d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1 2-2h2 M12 2v4 M8 4h8" />;
export const FileIcon = (p: ComponentIconProps) => <Icon {...p} d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9zM14 2v4a2 2 0 0 0 2 2h4" />;
export const EditIcon = (p: ComponentIconProps) => <Icon {...p} d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7 M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />;
export const UsersIcon = (p: ComponentIconProps) => <Icon {...p} d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M23 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75" />;